import React from 'react';

import AddressFormFields from './common/AddressFormFields';

type Address = { street?: string; street2?: string; city?: string; state?: string; zip?: string };

type Props = {
  values: { address?: Address };
  showErrors: boolean;
  errors: Record<string, string>;
  update: (path: string, val: unknown) => void;
};

export default function AddressStep({ values, showErrors, errors, update }: Props) {
  // State validation function for NY state check
  const stateValidation = (state: string) => {
    if (state === 'NY') {
      return {
        showError: true,
        error: 'New York is not currently supported.',
      };
    }
    return {
      showError: showErrors && !!errors['address.state'],
      error: errors['address.state'] || '',
    };
  };

  return (
    <>
      <p className='form-panel__page-subtitle'>
        Enter your address. When applicable, this is where we&apos;ll ship your collection kit.
      </p>
      <AddressFormFields
        fieldPrefix='address'
        address={values.address || {}}
        update={update}
        showErrors={showErrors}
        errors={errors}
        stateValidation={stateValidation}
      />
    </>
  );
}
